import { useEffect } from 'react';
import LangEnum from '../lang/LangEnum';
import { captureErrorInApm } from '../lib/apm/utils/captureErrorInApm.util';
import { ClarityEvents } from '../lib/clarity/types/clarityEvents.types';
import { captureEvent } from '../lib/clarity/utils/captureEvent.utils';
import { useNetworkContext } from '../modules/offline/contexts/network/network.context';
import { useOfflineQueryClientAlreadyHydratedInFirstRender } from '../modules/offline/queryClient/hooks/useOfflineQueryClientAlreadyHydratedInFirstRender';
import { useTranslation } from '../modules/translation/TranslationContext';
import { resetApp } from '../utils/resetApp.util';
import { useHasFinishedCountdownToInSeconds } from './useHasFinishedCountdownToInSeconds';

const MAX_TIME_TO_WAIT_FOR_LOADING_APP_IN_SECONDS = 20;

export const useHandleWhenWaitedTooMuchFirstLoading = (isLoadingApp: boolean) => {
  const { translate } = useTranslation();

  const { isLoadingOnlineStatus } = useNetworkContext();

  const offlineQueryClientAlreadyHydratedInFirstRender =
    useOfflineQueryClientAlreadyHydratedInFirstRender();

  const hasWaitedMaxTimeToWaitApp = useHasFinishedCountdownToInSeconds(
    MAX_TIME_TO_WAIT_FOR_LOADING_APP_IN_SECONDS,
  );

  useEffect(() => {
    const shouldCaptureError = hasWaitedMaxTimeToWaitApp && isLoadingApp;

    if (!shouldCaptureError) {
      return;
    }

    captureEvent(ClarityEvents.USER_WAITED_TOO_MUCH_TO_FIRST_LOADING);

    captureErrorInApm.infiniteLoadingError(
      new Error(
        `app loading timeout. offline query client hydrated state: ${offlineQueryClientAlreadyHydratedInFirstRender}, Loading: ${isLoadingOnlineStatus}`,
      ),
    );

    if (confirm(translate(LangEnum.CONFIRM_RESET_APP))) {
      resetApp();
    }
  }, [hasWaitedMaxTimeToWaitApp]);
};
